import request from '/@/utils/request'

export function getDictAll(key = 'all') {
  const query = { dictionary_key: key }
  return request({
    url: `/api/init/dictionary/`,
    params: query,
    method: 'get',
  })
}
